// ----------------------------------------------------------------------------
// Section: Expandable Cards
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------
import $ from 'jquery';
import Swiper, { Navigation, Pagination, Scrollbar, A11y, Keyboard, Thumbs } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import 'swiper/css/thumbs';
import './_expandable-cards.scss';

// -------------------------------------
// Variables
// -------------------------------------

// -------------------------------------
// Hooks
// -------------------------------------

function handleSlides(swiperEl) {
    swiperEl.slides.forEach(function(slide, index) {
        let slideLink = slide.querySelector('a');
        slideLink.addEventListener('focus', function(e) {
            swiperEl.slideTo(index);
        })
    });
}

function slideToSlide(slider, slideIndex, transition) {
    if (transition) {
        slider.slideTo(slideIndex);
    } else {
        slider.slideTo(slideIndex, 0);
    }
}

function toggleInnerFocus(slider) {
    let focusableElements = ['iframe', 'input', 'select', 'option', 'textarea', 'button', 'video', 'label', 'a', '.plyr', 'model-viewer'];
    $(focusableElements).each(function(index, el) {
        $(slider.slides).each(function(index, slide) {
            if (index === slider.activeIndex) {
                if (el === '.plyr') {
                    $(slide).find(el)
                    .attr('tabindex', "0");
                } else {
                    $(slide).find(el)
                    .removeAttr('tabindex');
                }
            } else {
                $(slide)
                .find(el)
                .attr('tabindex', '-1');
            }
        })
    })
}

$(function() {

    $(".carousel--expandable-card-thumbnails").each(function(index, element){
        var $this = $(this);

        // Generate unique class for each feature collection slider
        $this.addClass("expandable-card-thumbnails-instance-" + index);

        // Generate unique btn classes for slider arrows
        $this.parents('.expandable-cards').find(".swiper-button-prev").addClass("expandable-card-thumbnails-btn-prev-" + index);
        $this.parents('.expandable-cards').find(".swiper-button-next").addClass("expandable-card-thumbnails-btn-next-" + index);


        // Initialize feature collection slider based on the unique classes generated above.
        var swiper = new Swiper(".expandable-card-thumbnails-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard, Thumbs],
            slidesPerView: 1.5,
            spaceBetween: 5,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            keyboard: {
                enabled: false
            },
            touchMoveStopPropagation: true,

            breakpoints: {
            // when window width is >= 680px
            680: {
                slidesPerView: 5,
                spaceBetween: 5
            }
            },

             // // Navigation arrows
            navigation: {
                nextEl: ".expandable-card-thumbnails-btn-next-" + index,
                prevEl: ".expandable-card-thumbnails-btn-prev-" + index
            },
            multipleActiveThumbs: false
        });

        swiper.slides.forEach(function(slide, index) {
            let slideLink = slide.querySelector('.expandable-card-single__thumbnail');
            slideLink.addEventListener('focus', function(e) {
                swiper.slideTo(index);
            })
        });

        var expandableCardsSlider = $this.parents('.expandable-cards__container').find('.carousel--expandable-cards');

        // Generate unique class for each feature collection slider
        expandableCardsSlider.addClass("expandable-cards-instance-" + index);

        // Generate unique btn classes for slider arrows
        expandableCardsSlider.parents('.expandable-cards__content').find(".swiper-button-prev").addClass("expandable-cards-btn-prev-" + index);
        expandableCardsSlider.parents('.expandable-cards__content').find(".swiper-button-next").addClass("expandable-cards-btn-next-" + index);


        // Initialize feature collection slider based on the unique classes generated above.
        var swiper2 = new Swiper(".expandable-cards-instance-" + index, {
            // Optional parameters
            modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard, Thumbs],
            slidesPerView: 1,
            observer: true,
            observeParents: true,
            a11y: false,
            watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
            touchMoveStopPropagation: true,
            thumbs: {
                swiper: swiper,
            }
        });
        
        
        // Scrolls and selects specific card in slider based on #hash ID in URL
         $( window ).on( "load", function() {
            if(window.location.hash) {
                const expandableCards   = document.querySelector(".carousel--expandable-cards");
                const hash              = window.location.hash;
                const card_id           = document.querySelector(`.swiper-slide ${hash}`);
                
                if (typeof card_id !== 'undefined' && typeof expandableCards !== 'undefined') {
                    const slideIndex  = card_id.dataset.index;
                    const scrollFocus = expandableCards.getBoundingClientRect().top + window.pageYOffset - 150;
            
                    swiper2.slideTo(slideIndex, 200, false);
                    window.scrollTo({top: scrollFocus, behavior: 'smooth'});
                }   
        
            }
        });
    });
});
